<template>
<div class="animated fadeIn">
  <p>
    Total Amount: {{ totalAmount }}
  </p>
  <v-client-table :data="rooms" :columns="columns" :options="options" :theme="theme" id="reservationRoomsTable" ref="reservationRoomsTable">
    <template v-if="viewOnly == false" slot="actions" slot-scope="data">
      <b-button class="mr-1" size="sm" variant="primary" @click="deleteRoom(data.row)">Delete</b-button>
    </template>
    <span slot="has_toilet" slot-scope="data">{{data.row.has_toilet ? 'Yes' : 'No'}}</span>
    <span slot="has_ac" slot-scope="data">{{data.row.has_ac ? 'Yes' : 'No'}}</span>
  </v-client-table>
</div>
</template>

<script>
import Vue from 'vue'
import moment from 'moment'
import {
  mapState,
  mapActions
} from 'vuex'
import {
  required
} from "vuelidate/lib/validators"

export default {
  name: "RoomSelected",
  props: {
    reservation: Object,
    viewOnly: {
      type: Boolean,
      default: false
    } 
  },
  computed: {
    totalAmount() {
      let total = 0;
      let totalDays = this.stayDays();
      _.each(this.rooms, (room) => {
        total += parseFloat(room.price * totalDays)
      })
      total = _.round(total)
      return total
    },
    ...mapState({
      rooms: state => state.reservations.selectedRooms
    })
  },
  data() {
    return {
      columns: [
        'floor.building.name',
        'floor.floor_number',
        'room_number',
        'price',
        'number_of_beds',
        'max_occupiers',
        'toilet_type',
        'has_ac',
        'actions'
      ],
      options: {
        headings: {
          'floor.building.name': 'Building',
          'floor.floor_number': 'Floor',
          room_number: 'Room Number',
          price: 'Bhent/Day',
          number_of_beds: "Beds",
          max_occupiers: "Max Occupiers",
          toilet_type: "Toilet",
          has_ac: "AC",
          actions: 'Actions'
        },
        sortable: [],
        filterable: [],
        sortIcon: {
          base: 'fa',
          up: 'fa-sort-asc',
          down: 'fa-sort-desc',
          is: 'fa-sort'
        },
        pagination: {
          chunk: 5,
          edge: true,
          nav: 'scroll'
        },
        perPage: 25,
      },
      useVuex: false,
      theme: 'bootstrap4',
      template: 'default',
    }
  },
  methods: {
    stayDays() {
    let start = moment(this.reservation.arrival_date);
    let end = moment(this.reservation.departure_date);
    let duration = moment.duration(end.diff(start));
    let days = duration.asDays();
    return Math.round(days);
  },
    addRoom(room) {
      let selectedRooms = _.concat(this.rooms, room)
      this.$store.commit('reservations/setSelectedRooms', selectedRooms)
    },
    deleteRoom(room) {
      let selectedRooms = _.filter(this.rooms, item => item.id != room.id)
      this.$store.commit('reservations/setSelectedRooms', selectedRooms)
      this.$emit('deleted', room);
    },
    refresh() {
      this.$store.dispatch('reservations/getSelectedRooms', {id: this.reservation.id})
    }
  },
  created() {
    this.refresh()
  }
}
</script>
